import React from "react";
import Button, { IButtonData } from "../../Button";
import * as styles from "./component.module.scss";

const CarouselCard = ({
  title,
  content,
  imgUrl,
  button,
}: {
  title?: string;
  content?: string;
  imgUrl: string;
  button?: React.ReactNode | IButtonData;
}) => {
  return (
    <div className={styles.main}>
      <div className={styles.imgWrapper}>
        <img src={imgUrl} />
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.titleContentWrapper}>
          <span className={styles.title}>{title}</span>
          <span className={styles.content}>{content}</span>
        </div>
        <div className={styles.buttonWrapper}>
          {Button.getButtonFromDataOrNode(button, { variant: "slim" })}
        </div>
      </div>
    </div>
  );
};

export default CarouselCard;
